import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountNumberTitle: {
    defaultMessage: 'Account number',
    id: 'm7vyaO',
    description: 'Profile screen: payment section',
  },
  ruBicTitle: {
    defaultMessage: 'BIC',
    id: 'x3aYxn',
    description: 'Profile screen: payment section',
  },
  bankNameTitle: {
    defaultMessage: 'Bank name',
    id: 'M5lDg5',
    description: 'Profile screen: payment section',
  },
  correspondentAccountTitle: {
    defaultMessage: 'Correspondent account',
    id: 'Nbm+ly',
    description: 'Profile screen: payment section',
  },
  routingNumberTitle: {
    defaultMessage: 'Routing Number',
    id: 'us_routing_number_title',
    description: 'US routing number field title',
  },
  swiftTitle: {
    defaultMessage: 'Swift',
    id: 'GBRjyQ',
    description: 'Profile screen: payment section',
  },
  ibanTitle: {
    defaultMessage: 'IBAN',
    id: 'u+7Hx2',
    description: 'Profile screen: payment section',
  },
  uaeBicTitle: {
    defaultMessage: 'BIC',
    id: 'lk/sna',
    description: 'Profile screen: payment section UAE',
  },
  sortCodeTitle: {
    defaultMessage: 'Sort code',
    id: 'j10CLn',
    description: 'Profile screen: payment section',
  },
  title: {
    defaultMessage: 'Payment info',
    id: 'fQSGt7',
    description: 'Profile screen: subheader',
  },
  addAction: {
    defaultMessage: 'Add',
    id: 'H4zI7T',
    description: 'Profile screen: button text',
  },
  editAction: {
    defaultMessage: 'Edit',
    id: 'global_action_edit',
    description: 'Profile screen: button text',
  },
});
